import { endPoint } from './base.config';

export const transactionVoucher = {
  add: `${endPoint}transactionVoucher`,
  adminVoucherConnect: `${endPoint}transactionVoucher/adminVoucherConnect`,
  refreshMatchingVoucherTransaction: `${endPoint}transactionVoucher/refreshMatchingVoucherTransaction`,
};
